import CoreAdapter from "parog-web/adapters/core";

export default class ApplicationAdapter extends CoreAdapter {}
